/**
 * Configuration for client (i.e. browser).
 */
interface IConfig {
  /** Environment label, matching the environment variable. */
  ENV: string;
}

const config: { [env: string]: IConfig } = {
  local: {
    ENV: 'local'
  },
  dev: {
    ENV: 'dev'
  },
  staging: {
    ENV: 'staging'
  },
  live: {
    ENV: 'live'
  }
};

/**
 * Value indicating whether the current domain can be used to log in to view
 * admin and sample EMR pages.
 */
export const canLogin = (() => {
  if (document.location.hostname.startsWith('app')) {
    return false;
  } else {
    const env = ['staging', 'dev', 'local'];
    const host = ['observodon.cloud', 'viewlab.cloud'];
    const re = new RegExp(
      `^(\\w+)(?:\\.(?:${env.join('|')}))?\\.(?:${host
        .join('|')
        .replace(/\./g, '\\.')})$`
    );
    return re.test(document.location.hostname);
  }
})();

/** Version number injected by Dockerfile. */
export const SERVER_VERSION = 'BUILD__SERVER_VERSION';
/** Delay, in milliseconds, to wait for media to become available. */
export const NEW_MEDIA_DELAY_ms = 2500;
/** Interval, in ms, before fetching new data while waiting on e.g. upload. */
export const FAST_POLLING_ms = 10e3;
/** Interval, in ms, before fetching new data while idling, e.g. comments. */
export const STANDARD_POLLING_ms = 30e3;
/** Interval, in ms, fetching grade status. */
export const GRADE_STATUS_POLLING_ms = 300e3;
/** Number of characters in handoff challenge. */
export const CHALLENGE_LENGTH = 4;
/** Polling interval (ms) when checking for exchange codes. */
export const EXCHANGE_CODE_DELAY = 2000;
/** Maximum duration of video to upload, in minutes. */
export const MAX_VIDEO_DURATION_MIN = 5;
/** Maxiumum upload file size, in megabytes. */
export const MAX_UPLOAD_SIZE_MB = 200;

const env =
  process.env.REACT_APP_DEPLOYMENT_ENV ||
  ['local', 'dev', 'staging'].find((env) =>
    document.location.host.includes(`.${env}.`)
  ) ||
  (document.location.host.startsWith('localhost') ? 'local' : 'live');

export default config[env] || config.local;
